import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", {
  class: "alert alert-danger",
  "data-cy": "PayPortal.UnknownError.Alert"
}, " An unknown error occurred. ", -1)
const _hoisted_2 = { "data-cy": "PayPortal.UnknownError.Heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.UnknownError.Text" }, "Sorry for the inconvenience, you can try again but if the problem persists please contact support.", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)

import { defineProps } from '@vue/runtime-core';



export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
	className: string
}) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(__props.className), 1),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode("button", {
      type: "button",
      class: "btn btn-lg btn-default",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('start-over'))),
      "data-cy": "PayPortal.UnknownError.StartOverButton"
    }, "Start over")
  ]))
}
}

})